import { Button, Col, Container, Row } from "react-bootstrap";
import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class ResetTokenExpired extends Component {
  render() {
    return (
      <div className="body_container_wrapper login_page">
        <Container>
          <div className="login_wrapper">
            <Row>
              <Col md="6" className="mx-auto text-center">
                <div className="token-expired-message">
                  <h4>Password Reset Link Expired</h4>
                  <p>
                    The password reset link you used has either expired or has
                    already been used. Password reset links are valid for a
                    limited time and can only be used once for security reasons.
                  </p>
                  <p>Please request a new password reset link to continue.</p>
                  <Link to="/forgotpassword">
                    <Button variant="dark" className="mt-3">
                      Request New Password Reset
                    </Button>
                  </Link>
                  <div className="mt-3">
                    <Link to="/">Return to Home</Link>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    );
  }
}
